module.exports = __webpack_public_path__ + "img/Amriya2.2d1c6516.jpg";